import { AccountingPackageDto } from './dto/accounting-package.dto';

export class RevenueItem {
  public constructor() {
    this.ItemNum = 0;
    this.ItemName = '';
    this.Descr = '';
    this.AccountingPackageId = 0;
  }
  public ItemNum: number;
  public ItemName: string;
  public Descr: string;
  public UnitPrice: number;
  public Taxable: boolean;
  public BasePrice: number;
  public FlatFee: number;
  public GlAccountNum: string;
  public NormalBalance: string;
  public DuesType: boolean;
  public DateCreated: Date;
  public DateChanged: Date;
  public DeferredRevenue: boolean;
  public DebitAccount: string;
  public CreditAccount: string;
  public CashBasis: boolean;
  public TaxType: boolean;
  public TaxPercent: number;
  public TaxFlatAmount: number;
  public Inactive: boolean;
  public Pledge: boolean;
  public ProposalDescr: string;
  public ProposalPriceFormula: string;
  public ProposalRenewalFormula: string;
  public AgreementDescr: string;
  public ProposalURL: string;
  public AgreementURL: string;
  public AccountingPackageId: number;
  public AccountingPackageName: string;
  public PercentNotToDefer: number;
  public RevenueGroupID: number;
  public ClassTypeID: number;
  public QboClassId: string;
  public DefaultServicePeriodDays: number;
  public IntacctLocationID: number;
  public IntacctDepartmentID: number;

  public AccountingPackage: AccountingPackageDto;
}
